import React from 'react';

const PauseIcon = (props) => (
    <svg {...props} xmlns="http://www.w3.org/2000/svg" width={props.width ? props.width : '24'}
         height={props.height ? props.height : '24'} viewBox="0 0 24 24"
         fill={props.fill ? props.fill : 'currentColor'}
    >
        <rect x="6" y="4" width="4" height="16" rx="1"/>
        <rect x="14" y="4" width="4" height="16" rx="1"/>
    </svg>
);

export default PauseIcon;



// WEBPACK FOOTER //
// ./src/assets/icons/PauseIcon.jsx